import React from 'react';
import {MapPin, Navigation} from 'lucide-react';
import Button from '../../../../Presentation/components/ui/Button';
import {LocationPicker} from '../common/LocationPicker';
import {useNotification} from '../../../../Services/useNotification';

interface LocationSectionProps {
  showMap: boolean;
  selectedLocation: {lat: number; lng: number} | null;
  onLocationSelect: (_lat: number, _lng: number) => void;
  onToggleMap: () => void;
}

export const LocationSection: React.FC<LocationSectionProps> = ({
  showMap,
  selectedLocation,
  onLocationSelect,
  onToggleMap
}) => {
  const {success: showSuccess, error: showError} = useNotification();

  const getCurrentLocation = () => {
    if (typeof window !== 'undefined' && window.navigator?.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        (position) => {
          const {latitude, longitude} = position.coords;
          onLocationSelect(latitude, longitude);
          showSuccess('تم تحديد موقعك الحالي');
        },
        (error) => {
          // Use actual error message from browser geolocation API
          const errorMessage = error?.message || 'فشل في تحديد موقعك الحالي';
          showError(errorMessage);
        }
      );
    } else {
      // Client-side validation - browser doesn't support geolocation
      showError('متصفحك لا يدعم تحديد الموقع');
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
          <MapPin className="w-5 h-5" />
          الموقع
        </h3>
        <div className="flex gap-2">
          <Button
            type="button"
            variant="outline"
            size="small"
            onClick={getCurrentLocation}
            className="flex items-center gap-2"
          >
            <Navigation className="w-4 h-4" />
            موقعي الحالي
          </Button>
          <Button
            type="button"
            variant="outline"
            size="small"
            onClick={onToggleMap}
          >
            {showMap ? 'إخفاء الخريطة' : 'اختيار من الخريطة'}
          </Button>
        </div>
      </div>

      {selectedLocation && (
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm text-gray-600">
            <strong>الإحداثيات المحددة:</strong>
          </p>
          <p className="text-sm text-gray-800">
            خط العرض: {selectedLocation.lat.toFixed(6)}
          </p>
          <p className="text-sm text-gray-800">
            خط الطول: {selectedLocation.lng.toFixed(6)}
          </p>
        </div>
      )}

      {showMap && selectedLocation && (
        <div className="h-96 border border-gray-300 rounded-lg overflow-hidden">
          <LocationPicker
            initialLatitude={selectedLocation.lat}
            initialLongitude={selectedLocation.lng}
            onLocationChange={onLocationSelect}
          />
        </div>
      )}
    </div>
  );
};
